export const apiPath = '/v1/certificates';
const actionType = 'ASSET_AUDITS';

export default actionType;
